import React from 'react';
import { Route, IndexRoute, Redirect } from 'react-router';
import { DefaultPage, LandingPage, SearchPage, BuildPage, CommunityPage } from '../component/page/';
import { Layout } from '../component/Layout';

let defaultRoutes = [
  {
    path:'/',
    title:'Home',
    component:LandingPage
  },
  {
    path: '/pages/open-source/',
    title: 'Build',
    component: BuildPage
  },
  {
    path: '/pages/community-support/',
    title: 'Community & Support',
    component: CommunityPage
  },
  {
    path: '/search/',
    title: 'Search',
    component: SearchPage
  }
]

const requireAll = (requireContext) => {
  return requireContext.keys().map(requireContext);
}

var mods = requireAll(require.context("../content", true, /^\.\/.*\.md$/))

const routesMap = mods.map(obj => {
  return {
    path: obj.filename.replace('/content/','').replace('.md','/'),
    suffix: obj.suffix,
    title:obj.attributes.title || 'SLS Zone',
    component: DefaultPage,
    attributes: obj.attributes,
    content: obj.content,
    html: obj.html
  }
})


export const routes = (
  <Route path='/' component={Layout}>
    <IndexRoute title='SLS Zone' component={LandingPage} />
    {defaultRoutes.concat(routesMap).map((r,k)=>{
      return (<Route key={k} {...r} />);
    })}
    <Redirect from="/pages/meetup" to="/pages/meetup/" />
    <Redirect from="/meetup" to="/pages/meetup/" />
    <Route path='*' title='SLS Zone' component={LandingPage} />
  </Route>
);

export default routes;



// WEBPACK FOOTER //
// ./client/routes.js